import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import API from '../utils/api';

const DEFAULTS = {
  siteName: 'Lentera',
  siteTagline: 'Menyalakan Wawasan, Menginspirasi Perubahan',
  portalTagline: 'Setiap informasi bernilai inspirasi', portalTaglineSize: 18,
  siteDescription: 'Dari setiap karya lahir pengetahuan, dari setiap cerita tumbuh inspirasi, dan dari setiap gagasan tercipta perubahan.',
  siteUrl: '',
  contactEmail: '',
  copyrightText: 'PT Inspira Teknologi Nusantara',
  seo: {
    metaTitle: '', titleTemplate: '%s — %site%', metaDescription: '', keywords: '',
    canonicalBase: '', defaultOgImage: '', ogType: 'website', twitterCard: 'summary_large_image',
    twitterSite: '', twitterCreator: '', organizationName: '', organizationLogo: '', publisherName: '',
    robotsIndex: true, robotsFollow: true, googleVerification: '', bingVerification: '',
    gaMeasurementId: '', themeColor: '#001540', locale: 'id_ID', facebookAppId: '',
    sitemapEnabled: true, customHeadTags: '',
  },
  logoUrl: '',
  logoDarkUrl: '',
  faviconUrl: '',
  logoPortalUrl: '', logoPortalSize: 96,
  logoSidebarUrl: '', logoSidebarSize: 36,
  logoFooterUrl: '', logoFooterSize: 40,
  logoArticleNavbarUrl: '', logoArticleNavbarSize: 32,
  logoPortalSidebarUrl: '',
  logoPortalDarkUrl: '', logoSidebarDarkUrl: '', logoFooterDarkUrl: '',
  logoArticleNavbarDarkUrl: '', logoPortalSidebarDarkUrl: '',
  logoAuthUrl: '', logoAuthDarkUrl: '', logoEmailUrl: '',
  portalLayout: [
    { key: 'hero', label: 'Berita Utama (3 kolom)', visible: true },
    { key: 'sections', label: 'Section per Kategori', visible: true },
    { key: 'loadmore', label: 'Tombol Muat Lebih Banyak', visible: true },
  ],
  heroImageUrl: '',
  heroTitle: 'Dari setiap karya,\nlahir inspirasi.',
  heroSubtitle: 'Dari setiap karya lahir pengetahuan, dari setiap cerita tumbuh inspirasi, dan dari setiap gagasan tercipta perubahan.',
  heroBadgeText: 'Menyalakan Wawasan, Menginspirasi Perubahan',
  heroCtaPrimary: 'Mulai Sekarang',
  heroCtaSecondary: 'Masuk',
  colorPrimary: '#001540',
  colorAccent: '#D4690A',
  colorBackground: '#F5F7FA',
  colorBg2: '#FFFFFF', colorBg3: '#EEF2F8',
  colorText: '#0D1B2A',
  colorTextMuted: '#3D5A80', colorTextFaint: '#7A92A9',
  colorBorder: 'rgba(0,74,159,0.12)',
  colorCard: '#FFFFFF',
  colorSidebar: '#000D28',
  colorPortalSidebar: '#000D28',
  colorFooter: '#000D28',
  colorNavbarBg: '#FFFFFF',
  colorLink: '#004A9F', colorSuccess: '#059669', colorWarning: '#D4690A', colorDanger: '#DC2626',
  colorCtaBg: '#001540', colorCtaText: '#FFFFFF', colorAuthBg: '#F5F7FA', colorAuthCard: '#FFFFFF',
  colorAuthFooter: '#001540', colorAuthFooterText: '#FFFFFF', colorAuthButton: '#001540', colorAuthButtonText: '#FFFFFF',
  colorAuthLink: '#004A9F', colorAuthInput: '#FFFFFF', colorAuthInputBorder: '#D9DEE5',
  colorInvoiceHeader: '#001540', colorInvoiceHeaderText: '#FFFFFF', colorInvoiceCard: '#FFFFFF', colorInvoiceText: '#1A1A1A',
  darkColorPrimary: '#5B8BF5',
  darkColorAccent: '#D4690A',
  darkColorBackground: '#0A0A0B',
  darkColorBg2: '#141416',
  darkColorBg3: '#1A1A1D',
  darkColorCard: '#141416',
  darkColorText: '#F0F0F2',
  darkColorTextMuted: '#B4B4BC',
  darkColorTextFaint: '#7C7C86',
  darkColorBorder: 'rgba(255,255,255,0.10)',
  darkColorSidebar: '#000D28',
  darkColorPortalSidebar: '#000D28',
  darkColorFooter: '#000D28',
  darkColorNavbarBg: '#141416',
  darkColorLink: '#7BA3F8', darkColorSuccess: '#34D399', darkColorWarning: '#F7941D', darkColorDanger: '#F87171',
  darkColorCtaBg: '#141416', darkColorCtaText: '#F0F0F2', darkColorAuthBg: '#0A0A0B', darkColorAuthCard: '#141416',
  darkColorAuthFooter: '#000D28', darkColorAuthFooterText: '#F0F0F2', darkColorAuthButton: '#5B8BF5', darkColorAuthButtonText: '#0A0A0B',
  darkColorAuthLink: '#7BA3F8', darkColorAuthInput: '#1A1A1D', darkColorAuthInputBorder: 'rgba(255,255,255,0.12)',
  darkColorInvoiceHeader: '#000D28', darkColorInvoiceHeaderText: '#F0F0F2', darkColorInvoiceCard: '#141416', darkColorInvoiceText: '#F0F0F2',
  footerTagline: 'Platform dokumentasi inovasi, riset, dan pengabdian untuk sivitas akademika dan komunitas profesional Indonesia.',
  audienceTags: ['Dosen', 'Mahasiswa', 'Peneliti', 'Profesional', 'Masyarakat'],
  heroTopics: [
    { label: 'Inovasi', icon: 'FlaskConical' },
    { label: 'Riset', icon: 'BookOpen' },
    { label: 'Edukasi', icon: 'Cpu' },
    { label: 'Impact', icon: 'Users' },
    { label: 'Kolaborasi', icon: 'Factory' },
    { label: 'Inspirasi', icon: 'PenSquare' },
  ],
  footerLinks: [],
  externalLinks: [
    { label: 'inspiratekno.com', url: 'https://inspiratekno.com' },
    { label: 'InspiraLearn', url: 'https://lms.inspiratekno.com' },
  ],
  socialLinks: [],
  featureRegistration: true,
  featureAds: true,
  featureAdSubmission: true,
  featureGuestRead: true,
  featureArticleRequest: true,
  featureArticleRequestFree: false,
  paymentMode: 'midtrans', paymentAmount: 150000,
  priceStrikeEnabled: false, priceStrikeAmount: 0,
  bankName: 'Bank Mandiri', bankAccountNo: '1300 5 2112 2112', bankAccountName: 'PT. Nusa Inspira Teknologi',
  paymentInstruction: 'Transfer sesuai nominal, lalu unggah bukti transfer. Pembayaran akan diverifikasi admin dalam 1×24 jam.',
};

export function applyColors(s) {
  const root = document.documentElement;
  const isDark = root.getAttribute('data-theme') === 'dark';

  // Warna brand (biru/orange) selalu dari settings — relevan di terang & gelap
  root.style.setProperty('--in-orange', s.colorAccent);
  root.style.setProperty('--ki-orange', s.colorAccent);
  root.style.setProperty('--in-navbar-bg', s.colorNavbarBg);

  if (isDark) {
    // Mode gelap: terapkan skema warna dark dari admin (atau default dark).
    root.style.setProperty('--in-blue', s.darkColorPrimary || '#5B8BF5');
    root.style.setProperty('--in-orange', s.darkColorAccent || s.colorAccent);
    root.style.setProperty('--in-bg', s.darkColorBackground || '#0A0A0B');
    root.style.setProperty('--in-bg-2', s.darkColorBg2 || '#141416');
    root.style.setProperty('--in-bg-3', s.darkColorBg3 || '#1A1A1D');
    root.style.setProperty('--in-card', s.darkColorCard || '#141416');
    root.style.setProperty('--in-text', s.darkColorText || '#F0F0F2');
    root.style.setProperty('--in-text-muted', s.darkColorTextMuted || '#B4B4BC');
    root.style.setProperty('--in-text-faint', s.darkColorTextFaint || '#7C7C86');
    root.style.setProperty('--in-border', s.darkColorBorder || 'rgba(255,255,255,0.10)');
    // legacy aliases
    root.style.setProperty('--ki-blue', s.darkColorPrimary || '#5B8BF5');
    root.style.setProperty('--ki-bg', s.darkColorBackground || '#0A0A0B');
    root.style.setProperty('--ki-card', s.darkColorCard || '#141416');
    root.style.setProperty('--ki-text', s.darkColorText || '#F0F0F2');
    root.style.setProperty('--ki-text-muted', s.darkColorTextMuted || '#B4B4BC');
    root.style.setProperty('--ki-text-faint', s.darkColorTextFaint || '#7C7C86');
    root.style.setProperty('--ki-border', s.darkColorBorder || 'rgba(255,255,255,0.10)');
    // Panel khusus (mode gelap)
    root.style.setProperty('--in-sidebar', s.darkColorSidebar || '#000D28');
    root.style.setProperty('--in-portal-sidebar', s.darkColorPortalSidebar || '#000D28');
    root.style.setProperty('--in-footer', s.darkColorFooter || '#000D28');
    root.style.setProperty('--ki-sidebar', s.darkColorSidebar || '#000D28');
    // Token granular (mode gelap)
    root.style.setProperty('--in-navbar-bg', s.darkColorNavbarBg || '#141416');
    root.style.setProperty('--in-link', s.darkColorLink || '#7BA3F8');
    root.style.setProperty('--in-accent-green', s.darkColorSuccess || '#34D399');
    root.style.setProperty('--in-success', s.darkColorSuccess || '#34D399');
    root.style.setProperty('--in-warning', s.darkColorWarning || '#F7941D');
    root.style.setProperty('--in-accent-red', s.darkColorDanger || '#F87171');
    root.style.setProperty('--in-danger', s.darkColorDanger || '#F87171');
    root.style.setProperty('--in-cta-bg', s.darkColorCtaBg || '#141416');
    root.style.setProperty('--in-cta-text', s.darkColorCtaText || '#F0F0F2');
    root.style.setProperty('--in-auth-bg', s.darkColorAuthBg || '#0A0A0B');
    root.style.setProperty('--in-auth-card', s.darkColorAuthCard || '#141416');
    root.style.setProperty('--in-auth-footer', s.darkColorAuthFooter || '#000D28');
    root.style.setProperty('--in-auth-footer-text', s.darkColorAuthFooterText || '#F0F0F2');
    root.style.setProperty('--in-auth-button', s.darkColorAuthButton || '#5B8BF5');
    root.style.setProperty('--in-auth-button-text', s.darkColorAuthButtonText || '#0A0A0B');
    root.style.setProperty('--in-auth-link', s.darkColorAuthLink || '#7BA3F8');
    root.style.setProperty('--in-auth-input', s.darkColorAuthInput || '#1A1A1D');
    root.style.setProperty('--in-auth-input-border', s.darkColorAuthInputBorder || 'rgba(255,255,255,0.12)');
    root.style.setProperty('--in-invoice-header', s.darkColorInvoiceHeader || '#000D28');
    root.style.setProperty('--in-invoice-header-text', s.darkColorInvoiceHeaderText || '#F0F0F2');
    root.style.setProperty('--in-invoice-card', s.darkColorInvoiceCard || '#141416');
    root.style.setProperty('--in-invoice-text', s.darkColorInvoiceText || '#F0F0F2');
    return;
  }

  // Mode terang: terapkan skema warna terang dari settings (set eksplisit semua token
  // agar tidak ada sisa nilai dark yang nempel).
  const set = (k, v) => root.style.setProperty(k, v);
  set('--in-blue', s.colorPrimary);
  set('--in-bg', s.colorBackground);
  set('--in-bg-2', s.colorBg2 || '#FFFFFF');
  set('--in-bg-3', s.colorBg3 || '#EEF2F8');
  set('--in-text', s.colorText);
  set('--in-text-muted', s.colorTextMuted || '#3D5A80');
  set('--in-text-faint', s.colorTextFaint || '#7A92A9');
  set('--in-border', s.colorBorder || 'rgba(0,74,159,0.12)');
  set('--in-card', s.colorCard);
  set('--in-sidebar', s.colorSidebar);
  set('--in-footer', s.colorFooter || s.colorSidebar);
  set('--in-navbar-bg', s.colorNavbarBg || '#FFFFFF');
  set('--in-link', s.colorLink || '#004A9F');
  set('--in-accent-green', s.colorSuccess || '#059669');
  set('--in-success', s.colorSuccess || '#059669');
  set('--in-warning', s.colorWarning || '#D4690A');
  set('--in-accent-red', s.colorDanger || '#DC2626');
  set('--in-danger', s.colorDanger || '#DC2626');
  set('--in-cta-bg', s.colorCtaBg || '#001540');
  set('--in-cta-text', s.colorCtaText || '#FFFFFF');
  set('--in-auth-bg', s.colorAuthBg || '#F5F7FA');
  set('--in-auth-card', s.colorAuthCard || '#FFFFFF');
  set('--in-auth-footer', s.colorAuthFooter || '#001540');
  set('--in-auth-footer-text', s.colorAuthFooterText || '#FFFFFF');
  set('--in-auth-button', s.colorAuthButton || '#001540');
  set('--in-auth-button-text', s.colorAuthButtonText || '#FFFFFF');
  set('--in-auth-link', s.colorAuthLink || '#004A9F');
  set('--in-auth-input', s.colorAuthInput || '#FFFFFF');
  set('--in-auth-input-border', s.colorAuthInputBorder || '#D9DEE5');
  set('--in-invoice-header', s.colorInvoiceHeader || '#001540');
  set('--in-invoice-header-text', s.colorInvoiceHeaderText || '#FFFFFF');
  set('--in-invoice-card', s.colorInvoiceCard || '#FFFFFF');
  set('--in-invoice-text', s.colorInvoiceText || '#1A1A1A');
  // Sidebar portal terang: hapus override agar kembali ke default putih (CSS)
  root.style.removeProperty('--in-portal-sidebar');
  // legacy aliases
  set('--ki-blue', s.colorPrimary);
  set('--ki-bg', s.colorBackground);
  set('--ki-text', s.colorText);
  set('--ki-text-muted', s.colorTextMuted || '#3D5A80');
  set('--ki-text-faint', s.colorTextFaint || '#7A92A9');
  set('--ki-border', s.colorBorder || 'rgba(0,74,159,0.12)');
  set('--ki-card', s.colorCard);
  set('--ki-sidebar', s.colorSidebar);
}

const SiteSettingsContext = createContext({ settings: DEFAULTS, reload: () => {} });

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const load = useCallback(async () => {
    try {
      const res = await API.get('/settings');
      const s = { ...DEFAULTS, ...res.data.settings };
      setSettings(s);
      applyColors(s);
      if (s.siteName) document.title = s.siteName;
    } catch {
      applyColors(DEFAULTS);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // Re-apply warna setiap kali tema (data-theme) berubah, agar mode gelap
  // tidak tertimpa skema warna terang dari settings (atau sebaliknya).
  useEffect(() => {
    const observer = new MutationObserver(() => applyColors(settings));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, [settings]);

  // SEO global: favicon, Google Analytics (GA4), & custom head tags
  useEffect(() => {
    const seo = settings.seo || {};
    // Favicon dari settings
    if (settings.faviconUrl) {
      let fav = document.querySelector('link[rel="icon"]');
      if (!fav) { fav = document.createElement('link'); fav.rel = 'icon'; document.head.appendChild(fav); }
      fav.href = settings.faviconUrl;
    }
    // Google Analytics GA4
    if (seo.gaMeasurementId && !document.getElementById('ga4-script')) {
      const g = document.createElement('script');
      g.id = 'ga4-script'; g.async = true;
      g.src = `https://www.googletagmanager.com/gtag/js?id=${seo.gaMeasurementId}`;
      document.head.appendChild(g);
      const inline = document.createElement('script');
      inline.id = 'ga4-inline';
      inline.textContent = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${seo.gaMeasurementId}');`;
      document.head.appendChild(inline);
    }
    // Custom head tags (advanced) — disuntik sekali
    if (seo.customHeadTags && !document.getElementById('seo-custom-head')) {
      const wrap = document.createElement('div');
      wrap.id = 'seo-custom-head';
      wrap.style.display = 'none';
      wrap.innerHTML = seo.customHeadTags;
      document.head.appendChild(wrap);
    }
  }, [settings.seo, settings.faviconUrl]);

  return (
    <SiteSettingsContext.Provider value={{ settings, reload: load }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}
